// extracted by mini-css-extract-plugin
export default {"root":"Alerts_root_WyHT_"};